import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { getRootUrl } from 'helpers/url';
import { Search as SearchInput } from 'UI/Inputs';
import { Icon, Button, TooltipMenu, translate } from '@haldor/ui';
import './_web.scss';

var DesktopHeader = /*#__PURE__*/function (_Component) {
  _inherits(DesktopHeader, _Component);

  var _super = _createSuper(DesktopHeader);

  function DesktopHeader() {
    var _this;

    _classCallCheck(this, DesktopHeader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onSearch", function (search) {
      _this.props.history.push('/search?q=' + search.query);
    });

    _defineProperty(_assertThisInitialized(_this), "renderAction", function (action, index) {
      switch (action.type) {
        case 'button':
          return /*#__PURE__*/React.createElement(Button, {
            key: 'action-' + index,
            type: action.buttonType,
            disabled: action.disabled,
            onClick: action.onClick
          }, action.icon != null ? /*#__PURE__*/React.createElement(Icon, {
            name: action.icon
          }) : null, action.value);

        case 'dropDown':
          return /*#__PURE__*/React.createElement(TooltipMenu, {
            key: 'action-' + index,
            trigger: /*#__PURE__*/React.createElement(Button, {
              type: 'secondary',
              disabled: action.disabled
            }, action.icon != null ? /*#__PURE__*/React.createElement(Icon, {
              name: action.icon
            }) : null, action.value)
          }, action.subButtons ? action.subButtons.map(function (subAction, index) {
            return /*#__PURE__*/React.createElement(TooltipMenu.Item, {
              onClick: function onClick() {
                return subAction.onClick(true);
              },
              key: 'subAction-' + index
            }, subAction.value);
          }) : null);

        case 'icon':
          return /*#__PURE__*/React.createElement(Link, {
            to: "#",
            key: 'action-' + index,
            className: "header-action",
            "data-tooltip": action.tooltip,
            onClick: action.onClick
          }, action.icon != null ? /*#__PURE__*/React.createElement(Icon, {
            name: action.icon
          }) : null);

        default:
          return null;
      }
    });

    return _this;
  }

  _createClass(DesktopHeader, [{
    key: "render",
    value: function render() {
      var translate = this.props.translate;
      return /*#__PURE__*/React.createElement("div", {
        className: "desktop-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "content"
      }, /*#__PURE__*/React.createElement(Link, {
        to: getRootUrl()
      }, /*#__PURE__*/React.createElement("img", {
        src: "/dist/img/logo_type_small.png",
        className: "logotype"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "content right"
      }, /*#__PURE__*/React.createElement("div", {
        className: "actions"
      }, /*#__PURE__*/React.createElement(SearchInput, {
        placeholder: translate('search') + '...',
        onSubmit: this.onSearch,
        clearOnSubmit: true,
        lengthLimit: 3
      }), this.props.actions != null ? this.props.actions.map(this.renderAction) : null)));
    }
  }]);

  return DesktopHeader;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    actions: state.Header.actions
  };
}

export default withRouter(connect(mapStateToProps)(DesktopHeader));